module.exports = __webpack_public_path__ + "img/logo.2a88cc35.svg";